<template>
    <div id="app">
        <div class="button is-info" v-if="updateExists" @click="refreshApp">
            New version available - Click to update
        </div>
        <div id="nav">
            <router-link to="/">Chat with GUN DB and Vue.js - DApp</router-link>
        </div>
        <router-view/>
        <footer>
            <p><a href="https://github.com/dozyio/dapp-chat">Source Code</a> - Made with <span class="heart">❤️</span> by <a href="https://dozy.io/">dozy.io</a></p>
        </footer>
    </div>
</template>

<script>
export default {
    data() {
        return {
            refreshing: false,
            registration: null,
            updateExists: false
        }
    },
    created() {
        if(navigator.serviceWorker){
            document.addEventListener(
                'swUpdated', this.showRefreshUI, { once: true }
            );
            navigator.serviceWorker.addEventListener('controllerchange', () => {
                if (this.refreshing) return;
                this.refreshing = true;
                window.location.reload();
            });
        }
    },
    methods: {
        showRefreshUI (e) {
            // Display a button inviting the user to refresh/reload the app due
            // to an app update being available.
            // The new service worker is installed, but not yet active.
            // Store the ServiceWorkerRegistration instance for later use.
            this.registration = e.detail;
            this.updateExists = true;
        },
        refreshApp () {
            // Handle a user tap on the update app button.
            this.updateExists = false;

            // Protect against missing registration.waiting.
            if (!this.registration || !this.registration.waiting) { return; }
            this.registration.waiting.postMessage('skipWaiting');
        },
    }
}
</script>

<style lang="scss">
body {
    /* background by SVGBackgrounds.com */
    background-color: #330033;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='784' height='784' viewBox='0 0 800 800'%3E%3Cg fill='none' stroke='%23404' stroke-width='1'%3E%3Cpath d='M769 229L1037 260.9M927 880L731 737 520 660 309 538 40 599 295 764 126.5 879.5 40 599-197 493 102 382-31 229 126.5 79.5-69-63'/%3E%3Cpath d='M-31 229L237 261 390 382 603 493 308.5 537.5 101.5 381.5M370 905L295 764'/%3E%3Cpath d='M520 660L578 842 731 737 840 599 603 493 520 660 295 764 309 538 390 382 539 269 769 229 577.5 41.5 370 105 295 -36 126.5 79.5 237 261 102 382 40 599 -69 737 127 880'/%3E%3Cpath d='M520-140L578.5 42.5 731-63M603 493L539 269 237 261 370 105M902 382L539 269M390 382L102 382'/%3E%3Cpath d='M-222 42L126.5 79.5 370 105 539 269 577.5 41.5 927 80 769 229 902 382 603 493 731 737M295-36L577.5 41.5M578 842L295 764M40-201L127 80M102 382L-261 269'/%3E%3C/g%3E%3Cg fill='%23505'%3E%3Ccircle cx='769' cy='229' r='5'/%3E%3Ccircle cx='539' cy='269' r='5'/%3E%3Ccircle cx='603' cy='493' r='5'/%3E%3Ccircle cx='731' cy='737' r='5'/%3E%3Ccircle cx='520' cy='660' r='5'/%3E%3Ccircle cx='309' cy='538' r='5'/%3E%3Ccircle cx='295' cy='764' r='5'/%3E%3Ccircle cx='40' cy='599' r='5'/%3E%3Ccircle cx='102' cy='382' r='5'/%3E%3Ccircle cx='127' cy='80' r='5'/%3E%3Ccircle cx='370' cy='105' r='5'/%3E%3Ccircle cx='578' cy='42' r='5'/%3E%3Ccircle cx='237' cy='261' r='5'/%3E%3Ccircle cx='390' cy='382' r='5'/%3E%3C/g%3E%3C/svg%3E");
    min-height: 100vh;
    margin: 0;
}
#app {
    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
}

#nav {
    padding: 15px;

    a {
        font-weight: bold;
        color: #fff;

        &.router-link-exact-active {
            color: #fff;
            text-decoration: underline;
        }
    }
}
footer {
    color: white;
}
footer a {
    color: #fff;
    text-decoration: underline;
}
footer a:hover {
    color: #fff;
}
@media screen and (min-width: 769px){
    .heart { padding-right: 4px; }
}
</style>
